import store from '../../store'

export default function loggedIn ({ next }) {
  return store.getters.GET_OAUTH.access_token ? next({
    name: 'dashboard.main'
  }) : next()
}
